
// source: https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
export function generateGuid(): string {
  let replacer = c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);

  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, replacer);
}

// source https://stackoverflow.com/questions/43100718/typescript-enum-to-object-array
export function StringIsNumber(value) {
  return isNaN(Number(value)) === false;
}

export function enumToArray(enum_): any {
  let array = [];
  Object.keys(enum_).filter(StringIsNumber).forEach(key => array[key] = enum_[key]);
  return array;
}

export function enumToObjects(enum_): Array<any> {
  let objectArray: Array<any> = Object.keys(enum_).filter(StringIsNumber).map(key => ({ key, value: enum_[key] }));
  return objectArray;
}

export function dynamicSort(property,innerProperty=null) {
  var sortOrder = 1;
  if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }
  return function (a,b) {
      var pa = a[property];
      var pb = b[property];
      if (typeof pa === 'string') pa = pa.toLowerCase();
      if (typeof pb === 'string') pb = pb.toLowerCase();
      if (Array.isArray(pa) && innerProperty) pa = pa.map(p=> p[innerProperty]).toString();
      if (Array.isArray(pb) && innerProperty) pb = pb.map(p=> p[innerProperty]).toString();
      if (Array.isArray(pa) && !innerProperty) pa = pa.toString();
      if (Array.isArray(pb) && !innerProperty) pb = pb.toString();
      var result = (pa < pb) ? -1 : (pa > pb) ? 1 : 0;
      return result * sortOrder;
  }
}
